import React from "react";
import { Link } from "react-router-dom";

const CookiePolicy = () => {
  return (
    <div className="container mx-auto px-4 py-5">
      <br />
      <br />

      <div className="mx-auto bg-white p-4 rounded shadow" style={{ maxWidth: '800px' }}>
        <h1 className="display-5 fw-bold text-dark mb-4">
          Политика использования cookies
        </h1>
        
        <div className="text-dark">
          <section className="mb-4">
            <h2 className="h4 fw-semibold text-dark mb-3">
              Что такое cookies?
            </h2>
            <p className="mb-3">
              Cookies — это небольшие текстовые файлы, которые сохраняются на вашем устройстве 
              при посещении веб-сайтов. Они помогают нам улучшить работу сайта и предоставить 
              вам более персонализированный опыт.
            </p>
          </section>

          <section className="mb-4">
            <h2 className="h4 fw-semibold text-dark mb-3">
              Какие cookies мы используем?
            </h2>
            <div className="mb-3">
              <div className="p-3 bg-primary bg-opacity-10 rounded mb-3">
                <h3 className="fw-semibold text-primary mb-2">Обязательные cookies</h3>
                <p className="text-primary small">
                  Необходимы для корректной работы сайта, сохранения ваших предпочтений 
                  и результатов тестирования.
                </p>
              </div>
              
              <div className="p-3 bg-success bg-opacity-10 rounded mb-3">
                <h3 className="fw-semibold text-success mb-2">Аналитические cookies</h3>
                <p className="text-success small">
                  Помогают нам понимать, как посетители используют наш сайт, чтобы 
                  улучшить его функциональность и содержание.
                </p>
              </div>
              
              <div className="p-3 bg-info bg-opacity-10 rounded mb-3">
                <h3 className="fw-semibold text-info mb-2">Функциональные cookies</h3>
                <p className="text-info small">
                  Запоминают ваши настройки и предпочтения для более удобного 
                  использования сайта при повторных визитах.
                </p>
              </div>
            </div>
          </section>

          <section className="mb-4">
            <h2 className="h4 fw-semibold text-dark mb-3">
              Управление cookies
            </h2>
            <p className="mb-3">
              Вы можете управлять настройками cookies через настройки вашего браузера. 
              Однако отключение cookies может повлиять на функциональность сайта.
            </p>
            <div className="p-3 bg-warning bg-opacity-10 rounded">
              <p className="text-warning small">
                <strong>Обратите внимание:</strong> Отключение cookies может привести к 
                потере результатов тестов и необходимости повторного ввода данных.
              </p>
            </div>
          </section>

          <section className="mb-4">
            <h2 className="h4 fw-semibold text-dark mb-3">
              Контактная информация
            </h2>
            <p>
              Если у вас есть вопросы о нашей политике использования cookies, 
              свяжитесь с нами по адресу:{" "}
              <a href="mailto:developskillsnow@yandex.ru" className="text-primary text-decoration-underline">
                developskillsnow@yandex.ru
              </a>
            </p>
            <p>
              Или подробнее можно почитать в{" "}
              <a
                className="js-scroll px-2"
                style={{ color: "#0a018be7" }}
                href="https://docs.google.com/document/d/1TUpDa3QHENfx4vQJ2EaEvxPZ1RJ7NQbnNY2Dx-H5HIc/edit?usp=sharing"
                role="button"
                target="_blank"
                rel="noopener noreferrer"
              >
                этом документе
              </a>
              .
            </p>
          </section>
        </div>

        <div className="mt-4 pt-3 border-top">
          <Link
            to="/"
            className="btn btn-primary px-4 py-2"
          >
            Вернуться на главную
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CookiePolicy;